import React from 'react'
import { DropdownSelect } from '@vds/selects';
import { ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import { Button } from '@vds/buttons';
import { InHomeUtils } from './../../util/inhomeUtils';
import { updateCart } from './../../action/buildProduct';
import { Service } from './../../constants/actionType';
import { updateSCTags } from './../../service/dtmTag';
import { closeModalWindow } from './../../action/modalWindow'

export default class AddlIntrPackages extends React.Component {  
    constructor(props) {
        super(props);
        
        let { spanish, ...addlPackages } = this.props.packages; //Spanish packages to be removed from overlay
        this.getIntrPackageLaunguage = this.getIntrPackageLaunguage.bind(this);
        this.onClick = this.onClick.bind(this);
        this.addPkgToCart = this.addPkgToCart.bind(this);
        let allpckg = {};
        for(let i in addlPackages){
            allpckg[i.charAt(0).toUpperCase()+i.slice(1)] = addlPackages[i];
        }
        addlPackages = allpckg;
        this.state = {
            allPackages : addlPackages,
            selects : addlPackages ? Object.keys(addlPackages) : [], // Dropdown list populated from package language names
            dispPkg : addlPackages ? addlPackages[Object.keys(addlPackages)[0]] : null,
            selectedPkgs : this.props.selectedproducts && this.props.selectedproducts.length ? this.props.selectedproducts.map(p => p.prodId) : [],
            toAdd : [],
            toRemove : [],
            isBtnEnabled : false,
            dropDownValue : addlPackages ? Object.keys(addlPackages)[0] : '',
           announcement: ''
        }
        this.isReskin = props.buildProduct?.isReskin && props.lqState && props.lqState.runtimeKey && props.lqState.runtimeKey.EnableReskin === 'Y';
    }  

    getIntrPackageLaunguage = (e) =>{
        try
        {
            if (this.props) {
                let packtotal = this.props.packages[e.target.value.toLowerCase()];
                this.setState({
                    dispPkg : packtotal,
                    dropDownValue : e.target.value
                })
                updateSCTags('Language Selected -' + e.target.value);
            }
        }
        catch(ex)
        {
           // catchJSException('Checkout',this.props.visitId,'BAForm_updateUnitType',ex);
        } 
    }

    onClick = (pkg) => {
        this.setState({announcement: `Selected ${pkg.name} ${pkg.description} ${pkg.displayPrice}`})
        let toAdd = this.state.toAdd; //Packages selected
        let toRemove = this.state.toRemove; //PAckages unselected
        let currentPkgList = this.state.selectedPkgs; //Exisitng packages in cart
        let newPkgList = [];
        if(pkg && pkg.id) {
            if(currentPkgList.includes(pkg.id)) {
                if(!toRemove.includes(pkg.id)) {
                    toRemove.push(pkg.id)
                }
                if(toAdd.includes(pkg.id)) {
                    toAdd = toAdd.filter(id=> id !== pkg.id)
                }
            }
            else { 
                if (!toAdd.includes(pkg.id)) {
                    toAdd.push(pkg.id)
                    if(toRemove.includes(pkg.id)) {
                        toRemove = toRemove.filter(id=> id !== pkg.id)
                    }
                }
                let sameLanguageIds = this.getSameLanguageIds(pkg.id);
                if(sameLanguageIds) {
                    let exclusionProductId = currentPkgList.filter(x => sameLanguageIds.includes(x));
                    if(exclusionProductId && exclusionProductId.length) { //Remove the alternate same language package currently in cart
                        if(!toRemove.includes(exclusionProductId[0])) {
                            toRemove.push(exclusionProductId[0]) //alternate same language package added to toRemoveList
                        }
                        toAdd = toAdd.filter(id=> id !== exclusionProductId[0])
                    }
                }
            }
        }
        updateSCTags('Package Selected - ' + pkg.name);
        toAdd = toAdd.filter(id=> !toRemove.includes(id));
        newPkgList = [... new Set([...currentPkgList, ...toAdd])]; //New selected list will have only toAdd Packages
        newPkgList = newPkgList.filter(id=> !toRemove.includes(id)); //New selected list should not contain any toRemove packages
        this.setState({
            selectedPkgs : newPkgList,
            toAdd : toAdd,
            toRemove : toRemove,
            isBtnEnabled : true
        })
    }

    getSameLanguageIds = (id, language) => {
        let ids = [];
        if(id && this.state.allPackages && this.state.dropDownValue) {
            let sameLanguageProducts = this.state.allPackages[this.state.dropDownValue].filter(p => p.id !== id);
            if(sameLanguageProducts && sameLanguageProducts.length) {
                let sameLanguageIds = sameLanguageProducts.map(p => p.id)
                ids = sameLanguageIds;
            }
        }
        return ids;
    }

    addPkgToCart = () => {
        let addToCartIds = [];
        let removeFromCartIds = [];
        let isChecked =  false;
        if(this.state.toRemove && this.state.toRemove.length && this.props.selectedproducts && this.props.selectedproducts.length) {
            let filteredList = this.state.toRemove.filter(id=> !this.props.selectedproducts.includes(id));
            if(!this.state.toAdd.length && filteredList && filteredList.length === 1) {
                removeFromCartIds = filteredList;
                isChecked = true;
            }
            else {
                removeFromCartIds = filteredList.map(r => r+":remove");
            }
        }
        if(this.state.toAdd && this.state.toAdd.length) {
            addToCartIds = !this.state.toRemove.length && this.state.toAdd.length === 1 ? this.state.toAdd : this.state.toAdd.map(a => a+":add");
        }
        let updateCartIds = [...addToCartIds, ...removeFromCartIds].join(',');
        let selectedProd = Object.assign({}, this.state.allPackages[this.state.dropDownValue][0]);
        selectedProd.internationalPackages = updateCartIds;
        let selectedCoreServices = (InHomeUtils.isNotNull(this.props.cart) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail) && InHomeUtils.isNotNull(this.props.cart.cartOrderDetail.servicesOrdered)) ? this.props.cart.cartOrderDetail.servicesOrdered : '';
        let scProdName = this.state.allPackages[this.state.dropDownValue][0].name;
        scProdName = scProdName.split(" ")[0];
        if (scProdName) {
            if (this.state.allPackages[scProdName]) {
                for (let prodname = 0; prodname < this.state.allPackages[scProdName].length; prodname++) {
                    let getaddprodIds = updateCartIds.indexOf("add") > -1 ? updateCartIds.split(':add')[0] : updateCartIds;
                    if (this.state.allPackages[scProdName][prodname].id === getaddprodIds) {
                        updateSCTags("confirm - " + this.state.allPackages[scProdName][prodname].name);
                    }
                }
            }
        }
        this.props.closeOverlay();        
        if(updateCartIds) {
            updateCart(this.props.visitId,  this.props.lqState, selectedProd, Service.intrnlChnl, isChecked, this.props.dispatch, '', '',null, 'MTM', selectedCoreServices, false, false, null, this.props.buildProduct, this.props.buildProduct.loadedEquipments,this.props.appState.flowType);
        }
    }

    handleIntPackageKeyDown(pkg, e) {
        if (e.keyCode === 13 || e.keyCode === 32) {
           this.setState({announcement: `selected ${pkg.name} ${pkg.description} ${pkg.displayPrice}`})
            this.onClick(pkg);
            e.preventDefault();
        }
    }

    FiosCancel = () => {
        closeModalWindow(this.props.modalWindow.modalId, this.props.dispatch);
    }

    render() {
        //let selects = [];
        let selectedProducts = [];
        let addlPackageIds = [];
        let tileProducts = "";
        let productClass="";
        const buttonsGroup = (InHomeUtils.getdeviceType() === "mobile") ? "row margin-top-tiny margintop100" : "row margin-top-tiny";
        const centerStyle = { textAlign : 'center', margin:'-3rem auto'};
        //const { spanish, ...addlPackages } = this.props.packages; //Spanish packages to be removed from overlay
        // if (addlPackages) {
        //     selects = Object.keys(addlPackages) // Dropdown list populated from package language names
        // }
        // if (this.props.selectedproducts && this.props.selectedproducts.length) {
        //     this.props.selectedproducts.map(p => p.prodId && selectedProducts.push(p.prodId)) //selected class shoul apply if selectedproducts INCLUDES p.id
        // }       
        if(this.state.dispPkg !== null){
            tileProducts = this.state.dispPkg.map(pkg => {
                return (
                    <>
                    {<div id="" className={`addintPackReskinWrapper ${productClass}`} name="">
                            <div id={pkg.id} className={this.state.selectedPkgs && this.state.selectedPkgs.includes(pkg.id) ? "overlay w_blocks reskinBlock selected" : "overlay w_blocks reskinBlock"} name={pkg.name} iscustomgeneric="false" onClick={(e)=>this.onClick(pkg)} onKeyDown={(e) => this.handleIntPackageKeyDown(pkg, e)}>
                                <div id="INTLPKG" class="blocksEquipmentChoices overlay" data-customer-selection=""  title="Open Fios Five channel selection modal">
                                    <div class="inline-productClassblock vert-top text-left left reskinChioces">
                                        <div class="padding-bottom-micro">
                                            <div id="INTLPKG_NAME" className="reskinHeadingMDsame" data-type="">{pkg.name}</div>
                                            <div id="INTLPKG_DESC" class="reskinHeadingMDsameGrey">{pkg.description}</div>
                                        </div>
                                        <div id="INTLPKG_PRICE" class="blocks_choice-cost" data-equipment-cost="">{pkg.displayPrice}</div>
                                    </div>
                                </div>
                            </div>
                     </div>
                    }
                </>
                )
            })
        }
        
        
        return (
            <div className="ResknModalHeader">
                <ModalTitle>
                    Additional International Packages
                </ModalTitle>
                <ModalBody>
                    <div className="row" id="packlist">   
                    <p className={this.isReskin ? "margin-bottom-xlarge padding-bottom-micro" : ""}>Watch live TV from around the world with Verizon Fios.</p>
                    <div className="row margin-bottom-medium">
                        <div className="tiny-12 medium-12 columns medium-padding-left-zero">                            
                            <DropdownSelect label={"Select a language"} id="LanguageSelection" className="value language"  data-no-fancy="" tabIndex="0" 
                            onChange={(e) => this.getIntrPackageLaunguage(e)} value={this.state.dropDownValue} errorText="">                                                                    
                                {this.state.selects.map(s=> <option key={s} value={s}>{s}</option>)}                                    
                            </DropdownSelect>                                
                        </div>                           
                    </div>
                    </div>
                    <div aria-live="assertive" style={{ position: "absolute", left: '-9999px' }}>
                        {this.state.announcement}
                     </div> 
                    {/* Start Tile content here */}
                    <div style={{padding:'5px'}} className={this.isReskin ? "AIPTileWrapper AIPTileWrapperRskin" : "row AIPTileWrapper"} primitive="p">
                        {tileProducts.map((item,i)=>(
                            <div key={i} role='button' tabIndex={'0'} >{item}</div>
                        ))}
                    </div>
                </ModalBody>    
                <ModalFooter>    
                    {
                        <div className="row">
                            <div className="columns tiny-12 medium-6 large-6 tiny-margin-bottom-tiny">
                                <Button size="large" secondary={false} onClick={e => this.addPkgToCart()} width="100%">
                                    Confirm
                                </Button>
                            </div>
                            <div className="columns tiny-12 medium-6 large-6">
                                <Button size="large" secondary={true} id="AIPCancel" onClick={this.FiosCancel} width="100%">
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    }
                </ModalFooter>             
            </div>
        )
    }
}